import type { ExamResult } from "@/hooks/useStudentDashboard";
import EmptyState from "./EmptyState";

interface ExamSummaryProps {
  lastExam: ExamResult | null;
  loading: boolean;
}

export default function ExamSummary({ lastExam, loading }: ExamSummaryProps) {
  if (loading) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Son Deneme</h3>
        <div className="mt-4 h-16 rounded-md bg-background-100 animate-pulse" />
      </div>
    );
  }

  if (!lastExam) {
    return (
      <EmptyState
        icon="ri-file-text-line"
        title="Deneme sonucu yok"
        description="İlk deneme sonucun tamamlandığında burada görünecek."
      />
    );
  }

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 h-full">
      <h3 className="font-heading font-semibold text-base text-foreground-950">Son Deneme</h3>
      <p className="mt-1 text-sm text-foreground-700">{lastExam.exam_name}</p>

      <div className="mt-4 flex items-center gap-4">
        <div className="text-center">
          <p className="text-2xl md:text-3xl font-heading font-bold text-primary-700">{lastExam.net}</p>
          <p className="text-xs text-foreground-500">Net</p>
        </div>
        <div className="flex-1 grid grid-cols-3 gap-2 text-center">
          <div className="rounded-md bg-accent-50 px-2 py-2">
            <p className="text-base font-semibold text-accent-800">{lastExam.correct_count}</p>
            <p className="text-[10px] text-foreground-500">Doğru</p>
          </div>
          <div className="rounded-md bg-background-100 px-2 py-2">
            <p className="text-base font-semibold text-foreground-800">{lastExam.wrong_count}</p>
            <p className="text-[10px] text-foreground-500">Yanlış</p>
          </div>
          <div className="rounded-md bg-background-100 px-2 py-2">
            <p className="text-base font-semibold text-foreground-800">{lastExam.blank_count}</p>
            <p className="text-[10px] text-foreground-500">Boş</p>
          </div>
        </div>
      </div>
    </div>
  );
}